/* ================================================== */
/* CHECK IE
/* ================================================== */

function checkIe() {

	var ua   = window.navigator.userAgent,
		msie = ua.indexOf('MSIE '),
		edge = ua.indexOf('Edge/');

	if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
		$('html').attr('data-browser', 'ie-11');
		return true;
	} else if (edge > 0) {
		$('html').attr('data-browser', 'ie-edge');
		return true;
	}

}

$(document).ready(checkIe());